/**
 * Onboarding route group layout.
 *
 * Expo Router route group: files in `app/(onboarding)/` are
 * siblings of each other in URL (e.g. `welcome.tsx` → `/welcome`),
 * but share this layout. The root `app/_layout.tsx` still wraps
 * everything; this nested Stack only overrides header + animation.
 *
 * Why no header:
 *  - Each step renders its own header inside OnboardingStepShell
 *    ("Kembali" / "Lewati" buttons).
 *  - Step 0 (story) is full-screen and renders no header.
 *
 * Why slide_from_right:
 *  - Matches a forward "next step" gesture in Bahasa UI; reverse
 *    is the default left slide. `simple_push` felt too abrupt in
 *    prototype testing.
 *
 * OnboardingProvider scope:
 *  - Wraps the Stack so all 7 step screens share deviceId + currentChild
 *  - Mounted once per group entry; not lifted to the root layout because
 *    home / library / parent zone flows will own their own state.
 */

import { Stack } from 'expo-router/stack';

import { OnboardingProvider } from '@/contexts/onboarding-context';

const CREAM_BG = '#ffffff';

export default function OnboardingLayout() {
  return (
    <OnboardingProvider>
      <Stack
        screenOptions={{
          headerShown: false,
          animation: 'slide_from_right',
          animationDuration: 220,
          contentStyle: { backgroundColor: CREAM_BG },
        }}
      />
    </OnboardingProvider>
  );
}
